import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const WishlistContext = createContext(null);

export const useWishlist = () => useContext(WishlistContext);

export const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      fetchWishlist();
    } else {
      const localWishlist = JSON.parse(localStorage.getItem('guestWishlist') || '[]');
      setWishlist(localWishlist);
    }
  }, [isAuthenticated]);

  const fetchWishlist = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/wishlist`);
      setWishlist(response.data);
    } catch (error) {
      console.error('Error fetching wishlist:', error);
    } finally {
      setLoading(false);
    }
  };

  const addToWishlist = async (product) => {
    if (isAuthenticated) {
      try {
        await axios.post(`${API}/wishlist/add`, { product_id: product.id });
        await fetchWishlist();
      } catch (error) {
        console.error('Error adding to wishlist:', error);
      }
    } else {
      if (!wishlist.find(item => item.id === product.id)) {
        const newWishlist = [...wishlist, product];
        setWishlist(newWishlist);
        localStorage.setItem('guestWishlist', JSON.stringify(newWishlist));
      }
    }
  };

  const removeFromWishlist = async (productId) => {
    if (isAuthenticated) {
      try {
        await axios.delete(`${API}/wishlist/remove/${productId}`);
        await fetchWishlist();
      } catch (error) {
        console.error('Error removing from wishlist:', error);
      }
    } else {
      const newWishlist = wishlist.filter(item => item.id !== productId);
      setWishlist(newWishlist);
      localStorage.setItem('guestWishlist', JSON.stringify(newWishlist));
    }
  };

  const isInWishlist = (productId) => {
    return wishlist.some(item => item.id === productId);
  };

  return (
    <WishlistContext.Provider value={{
      wishlist,
      loading,
      addToWishlist,
      removeFromWishlist,
      isInWishlist,
      wishlistCount: wishlist.length
    }}>
      {children}
    </WishlistContext.Provider>
  );
};
